module.exports = "/img/14.56977b.webp";